// extracted by mini-css-extract-plugin
export var columnList = "_fr-0";